



















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getRuntimeHistory } from '@/api/videoDevice/point'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import { dateFormat, mergeDateTimeRange, splitDateRange } from '@/configs/functions'

@Component({
  components: {
    ViewDialog
  }
})
export default class VideoStatusRuntimeHistory extends Vue {
  public name = 'VideoStatusRuntimeHistory'

  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false
  public popPageSize: number = window.baseConfig.PopPageSize
  public loading: boolean = false
  public list: any = []
  public pointId: number = 0
  public dateTimeFormat = window.baseConfig.DateTimessFormat
  private sDate = this.defDate(true)
  private eDate = this.defDate(false)
  private defDate(start: boolean) {
    var format = window.baseConfig.DateFormat
    var today = new Date()
    var dt = dateFormat(today, format)
    if (start) {
      //默认查7天的记录
      today.setTime(today.getTime() - 1000 * 60 * 60 * 24 * 7)
      dt = dateFormat(today, format)
      dt += " 00:00:00"
    }
    else {
      dt += " 23:59:59"
    }
    return dt
  }  
  get dateRange(): string[] {
    // console.log(this.sDate, this.eDate)
    const qt = this.queryTerm
    return mergeDateTimeRange(qt.StartDate, qt.EndDate)
  }
  set dateRange(range: string[]) {
    const qt = this.queryTerm
    const d = splitDateRange(range)
    qt.StartDate = d.start
    qt.EndDate = d.end
  }
  public queryTerm: any = {
    Page: 1,
    PageSize: this.popPageSize,
    PointId: this.pointId,
    StartDate: this.sDate,
    EndDate: this.eDate,
    Keyword: ""
  }
  public totalItems: number = 0
  public hasMore: boolean = false

  public mounted() {
    window.eventBus.$on("showRuntimeHistory", (pointId: number) => {
      this.pointId = pointId
      this.open()
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("showRuntimeHistory")
  }
  public open() {
    this.showDialog = true
    //重置控件
    this.totalItems = 0
    this.hasMore = false
    this.queryTerm = {
      Page: 1,
      PageSize: this.popPageSize,
      PointId: this.pointId,
      StartDate: this.sDate,
      EndDate: this.eDate,
      Keyword: ""
    }
    this.list = []
    this.doSearch()
  }
  public close() {
    this.showDialog = false
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  // 查询用户所在地的文保单位
  public doSearch() {
    this.queryTerm.Page = 1
    this.list = []
    this.fetchData()
  }
  public fetchData() {
    this.loading = true
    this.totalItems = 0
    getRuntimeHistory(this.queryTerm).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        //后台读取pageSize条，第pageSize条用来判断是否全部查询
        const list = data.Results
        const pageSize = this.queryTerm.PageSize
        this.totalItems = data.TotalCount
        const curList = this.list
        if (curList.length == 0) {
          this.list = list
        }
        else {
          this.list = curList.concat(list)
        }
        this.hasMore = (this.totalItems > this.list.length)
        this.loading = false
      }
    })
  }
  public fetchMore() {
    if (this.hasMore) {
      this.queryTerm.Page++
      this.fetchData()
    }
  }
}
